// src/components/onboarding/screens/FierteScreen.js
import React from 'react';
import { Mic, X, Check } from 'lucide-react';
import OnboardingLayout from '../OnboardingLayout';
import { ScreenTitle } from '../OnboardingUI';
import { TOTAL_STEPS } from '../onboardingData';
import { useVoiceRecorder } from '../../../hooks/useVoiceRecorder';
import VoiceWaveform from '../../ui/VoiceWaveform';

const FierteScreen = ({ fierte, genre, onChange, onNext, loading, error }) => {
  const isFeminin = genre === 'F' || genre === 'girl';
  const accordFier = isFeminin ? 'fière' : 'fier';
  const accordSeul = isFeminin ? 'seule' : 'seul';

  const { recording, transcribing, stream, startRecording, confirmRecording, cancelRecording } =
    useVoiceRecorder((transcript) => onChange(transcript));

  const busy = recording || transcribing;

  return (
    <OnboardingLayout
      currentStep={6}
      totalSteps={TOTAL_STEPS}
      canProceed={!busy}
      onNext={onNext}
      loading={loading}
      error={error}
      buttonText="Terminer"
    >
      <ScreenTitle title={`Un truc dont tu es ${accordFier} ?`} />
      <p className="text-gray-400 mb-1">
        Un projet, un défi relevé, quelque chose que tu as osé faire...
      </p>
      <p className="text-gray-500 text-sm mb-5">Ça peut être court.</p>

      <div className="relative flex-1 flex flex-col">
        <textarea
          value={transcribing ? '⏳ Transcription en cours...' : fierte}
          onChange={(e) => onChange(e.target.value)}
          placeholder={`Ex: J'ai organisé un tournoi avec mes potes / J'ai appris la guitare ${accordSeul} / J'ai osé parler en public...`}
          className="flex-1 w-full p-4 pb-12 bg-gray-800/50 border border-gray-700 rounded-xl text-white placeholder-gray-500 focus:border-emerald-500 focus:outline-none resize-none"
          disabled={loading || busy}
        />

        {recording ? (
          <div className="absolute bottom-2 left-3 right-3 flex items-center gap-2">
            <div className="flex-1">
              <VoiceWaveform isRecording={recording} stream={stream} />
            </div>
            <button
              onClick={cancelRecording}
              className="p-1.5 rounded-full bg-gray-700 hover:bg-gray-600 transition"
              title="Annuler"
            >
              <X size={16} />
            </button>
            <button
              onClick={confirmRecording}
              className="p-1.5 rounded-full bg-emerald-600 hover:bg-emerald-500 transition"
              title="Valider"
            >
              <Check size={16} />
            </button>
          </div>
        ) : (
          <button
            onClick={startRecording}
            disabled={loading || transcribing}
            className="absolute bottom-3 right-3 p-2 rounded-full bg-gray-700 hover:bg-gray-600 transition disabled:opacity-40"
            title="Dicter"
          >
            <Mic size={18} />
          </button>
        )}
      </div>
    </OnboardingLayout>
  );
};

export default FierteScreen;
